import React, { useState, useEffect } from 'react';
import { AlertCircle, CheckCircle, X } from 'lucide-react';

const AgeVerification = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setShowPopup(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    localStorage.setItem('ageVerifiedDate', new Date().toISOString());
    setShowPopup(false);
  };

  const handleDecline = () => {
    alert('You must be 18 or older to access this website. You will now be redirected.');
    window.location.href = 'https://www.begambleaware.org/';
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="glass rounded-3xl p-8 md:p-12 max-w-md mx-4 relative border-2 border-yellow-400/30">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-20 h-20 glass rounded-full mb-6 border-2 border-yellow-400/50">
            <AlertCircle className="text-yellow-400" size={40} />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Age Verification
          </h2>
          <p className="text-lg text-white/80 leading-relaxed mb-2">
            You must be 18 or older to access this website.
          </p>
          <p className="text-base text-white/70 leading-relaxed">
            By clicking "I am 18 or older", you confirm that you are of legal age to access gambling-related content in the United Kingdom.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 mt-8">
          <button
            onClick={handleDecline}
            className="flex-1 glass px-6 py-3 rounded-xl text-white font-semibold hover:bg-white/20 transition-all duration-300 border border-white/20"
          >
            I am under 18
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 glass px-6 py-3 rounded-xl text-white font-semibold hover:bg-yellow-400/20 transition-all duration-300 border-2 border-yellow-400/50 flex items-center justify-center space-x-2"
          >
            <CheckCircle size={20} />
            <span>I am 18 or older</span>
          </button>
        </div>

        <p className="text-xs text-white/50 text-center mt-6">
          Brit Wager is intended for users aged 18 and over only. Please gamble responsibly.
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;

